import { createBrowserHistory } from "history";

var history = () => {
  return createBrowserHistory();
};

export default history();
